import * as React from "react";

import { isAfter } from "date-fns";

import { getFeatureToggles } from "@teamprevent/common/getFeatureToggles";
import * as FeatureToggleNames from "@teamprevent/common/featureToggleNames";

export interface LegalAddressProps {
    immsCompletionDate: Date;
}

// 18th September 2024
const DateOfLegalAddressChange = new Date(2024, 8, 18);

export const LegalAddress: React.FC<LegalAddressProps> = ({ immsCompletionDate }) => {
    const featureToggles = getFeatureToggles();
    const updateImmsClearCertificateAddress = featureToggles[FeatureToggleNames.UpdateImmsClearCertificateAddress];

    if (!updateImmsClearCertificateAddress) {
        return (
            <>
                <p>TP Health Ltd part of Optima Health, a division of Marlowe plc.</p>
                <p>Our Registered Office is 20 Grosvenor Place, London, England, SW1X 7HN.</p>
                <p>We are registered in England and Wales with Registered Number 05770728.</p>
            </>
        );
    }

    if (isAfter(immsCompletionDate, DateOfLegalAddressChange)) {
        return (
            <>
                <p>TP Health a subsidiary of <strong>Optima Health Plc.</strong></p>
                <p>Our Registered Office is Meadow Court, 2 Hayland Street, Sheffield, England, S9 1BY.</p>
                <p>We are registered in England and Wales with Registered Number 5770728.</p>
            </>
        );
    } else {
        return (
            <>
                <p>TP Health Ltd part of Optima Health, a division of Marlowe plc.</p>
                <p>Our Registered Office is 20 Grosvenor Place, London, England, SW1X 7HN.</p>
                <p>We are registered in England and Wales with Registered Number 05770728.</p>
            </>
        );
    }
};
